// Copyright 2026 Imprivata, Inc. All rights reserved.

import { inviteImprIdpUsers } from '@api/portalServices';
import type { UsersInviteRequest } from '@api/types';
import { useMutation } from '@tanstack/react-query';

export const useInviteUsers = () => {
  return useMutation({ mutationFn: (data: UsersInviteRequest) => inviteImprIdpUsers(data) });
};
